/* Vanilla js */
document.addEventListener("DOMContentLoaded", function() {

  // View more
  viewMore();
  function viewMore(){
    const viewMoreContent = document.querySelectorAll('.view-more-content');

    if (viewMoreContent.length > 0){
      for (var i = 0 ; i < viewMoreContent.length; i++) {

        if (viewMoreContent[i].classList.contains('short-view-more-content')){
          if (viewMoreContent[i].offsetHeight > 80) {
            viewMoreContent[i].classList.add('cms-collapsed');
            viewMoreContent[i].nextElementSibling.classList.add('show');
          }
        } else {
          if (viewMoreContent[i].offsetHeight > 189) {
            viewMoreContent[i].classList.add('cms-collapsed');
            viewMoreContent[i].nextElementSibling.classList.add('show');
          }
        }

      }
    }
  };

  // View More Link
  const viewMoreLink = document.querySelectorAll('.view-more-link');
  if ( document.contains(viewMoreLink[0]) ){
    for (var i = 0 ; i < viewMoreLink.length; i++) {
      viewMoreLink[i].addEventListener('click' , function(e){
        e.preventDefault();
        this.classList.toggle('toggle');
        this.previousElementSibling.classList.toggle('cms-collapsed');
      } , false ) ;
    }
  }

});

/* jquery */
$(document).ready(function () {

  /* reliance - testimonials section */
  $('.avis-slider').slick({
    arrows: true,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13.775 17.6625L12.95 16.8625L17.25 12.5625H4V11.4375H17.25L12.925 7.11252L13.75 6.33752L19.425 11.9875L13.775 17.6625Z" fill="currentColor"/></svg></button>',
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.225 6.33748L11.05 7.13748L6.75 11.4375L20 11.4375L20 12.5625L6.75 12.5625L11.075 16.8875L10.25 17.6625L4.575 12.0125L10.225 6.33748Z" fill="currentColor"/></svg></button>',
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  /* reliance - presse section */
  $('.presse-list').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToShow: 5,
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13.775 17.6625L12.95 16.8625L17.25 12.5625H4V11.4375H17.25L12.925 7.11252L13.75 6.33752L19.425 11.9875L13.775 17.6625Z" fill="currentColor"/></svg></button>',
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.225 6.33748L11.05 7.13748L6.75 11.4375L20 11.4375L20 12.5625L6.75 12.5625L11.075 16.8875L10.25 17.6625L4.575 12.0125L10.225 6.33748Z" fill="currentColor"/></svg></button>',
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true,
          dots: false,
          arrows: false,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  /* reliance - reinsurance section */
  $('.reassurance-list').slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 400,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    mobileFirst: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          dots: false,
          arrows: false,
        }
      },
      {
        breakpoint: 1024,
        settings: "unslick"
      }
    ]
  });
});



